import type { QueryClient } from '@tanstack/react-query'

/**
 * Invalidates only the issue-list queries scoped to a specific target entity.
 * Not a React hook despite living under hooks/ — named without the `use`
 * prefix so eslint's react-hooks/rules-of-hooks does not flag callers that
 * invoke it from `onSuccess` callbacks.
 */
export function refreshEntityIssues(
    queryClient: QueryClient,
    targetEntityUid: string,
) {
    queryClient.invalidateQueries({
        predicate: (query) => {
            const key = query.queryKey as unknown[]
            if (key.length < 2 || key[0] !== 'get') return false
            if (key[1] !== '/api/v1/organizations/{orgCode}/issues') return false
            const paramsEntry = key.find(
                (x) => x && typeof x === 'object' && 'params' in (x as Record<string, unknown>),
            ) as { params?: { query?: { target_entity_uid?: string } } } | undefined
            return paramsEntry?.params?.query?.target_entity_uid === targetEntityUid
        },
    })
}
